import { moduleRegistry } from "../../modules/moduleRegistry";

const DIRECT_CONSUMER_KEYS = [
  "bkg_agent",
  "collaboration_chat_enabled",
  "ida_follow_up_suggestions",
  "meridian_rag_sources",
  "meridian_structure_agent",
  "meridian_thinking_sections",
  "skill_invocation_attribution",
];

const registryFeatureKeys = Object.values(moduleRegistry).flatMap((module) => [
  ...module.routes
    .map((route) => route.requiredFeature)
    .filter((feature): feature is string => Boolean(feature)),
  ...(module.navigation || [])
    .map((item) => item.requiredFeature)
    .filter((feature): feature is string => Boolean(feature)),
]);

export const KNOWN_FEATURE_FLAG_KEYS = Array.from(
  new Set([...DIRECT_CONSUMER_KEYS, ...registryFeatureKeys]),
).sort();

const knownFeatureFlagKeySet = new Set(KNOWN_FEATURE_FLAG_KEYS);

export const isKnownFeatureFlagKey = (flagKey: string) =>
  knownFeatureFlagKeySet.has(flagKey);
